<template>
  <div class="o-page__content u-pt-small">
    <div class="container-fluid">
      <div class="row u-mb-medium">
        <div class="col-12 col-xl-12">
          <h1 class="u-h3">Employees</h1>
          <div class="custom_toolbar">
            <Select2
              class="c-input"
              v-if="user_role_id == 1"
              v-model="params.region"
              :options="regions"
              :settings="{ width: '100%', placeholder: 'All Region' }"
              @change="myChangeEvent($event)"
              @select="mySelectEvent($event)"
            />
            <Select2
              class="c-input"
              v-model="params.branch"
              :options="branches"
              :settings="{ width: '100%', placeholder: 'All Branch' }"
              @change="myChangeEvent2($event)"
            />
            <Select2
              class="c-input"
              v-model="params.outlet"
              :options="outlets"
              :settings="{ width: '100%', placeholder: 'All Outlet' }"
              @change="myChangeEvent3($event)"
            />
            <Select2
              class="c-input"
              v-model="params.position"
              :options="positions"
              :settings="{ width: '100%', placeholder: 'All Position' }"
              @change="myChangeEvent4($event)"
            />
            <Select2
              class="c-input"
              v-model="params.default_password"
              :options="passwords"
              :settings="{ width: '100%', placeholder: 'Filter' }"
              @change="fetch"
            />
            <!-- <input type="text" placeholder="Search..." class="c-input" v-model="params.q" v-on:keyup="search"> -->
          </div>
          <div class="custom_toolbar u-mt-small">
            <input
              type="text"
              placeholder="Search..."
              class="c-input"
              v-model="params.q"
              v-on:keyup="search"
            />
            <el-button
              v-if="user_role_id == 1"
              @click="exportData"
              style="margin-left: 10px"
              type="primary"
              size="mini"
              icon="el-icon-download"
              >Export</el-button
            >
            <el-button
              v-if="user_role_id == 1"
              @click="dialogVisible = true"
              style="margin-left: 10px"
              type="warning"
              size="mini"
              icon="el-icon-plus"
              >Import</el-button
            >
            <el-button
              v-if="user_role_id == 1"
              @click="AddUser()"
              style="margin-left: 10px"
              type="success"
              size="mini"
              icon="el-icon-plus"
              >Add New</el-button
            >

            <el-button
              v-if="user_role_id == 2"
              @click="exportData"
              style="margin-left: 10px"
              type="primary"
              size="mini"
              icon="el-icon-download"
              >Export</el-button
            >
            <el-button
              v-if="user_role_id == 2"
              @click="AddUser()"
              style="margin-left: 10px"
              type="success"
              size="mini"
              icon="el-icon-plus"
              >Add New</el-button
            >
          </div>
        </div>
      </div>
      <div class="row" v-if="user_role_id == 1">
        <div class="col-sm-12 col-lg-6 col-xl-3" v-if="summary">
          <div class="c-state-card">
            <div class="c-state-card__icon c-state-card__icon--success">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="c-state-card__content">
              <h5 class="c-state-card__number">
                {{ summary.total_employee.toLocaleString("ID") }}
              </h5>
              <p class="c-state-card__meta">Total Employees</p>
            </div>
          </div>
        </div>
        <!-- // .col-md-3 -->
        <div class="col-sm-12 col-lg-6 col-xl-3" v-if="summary">
          <div class="c-state-card">
            <div class="c-state-card__icon c-state-card__icon--fancy">
              <i class="el-icon-info"></i>
            </div>
            <div class="c-state-card__content">
              <h5 class="c-state-card__number">
                {{ summary.total_login.toLocaleString("ID") }}
              </h5>
              <p class="c-state-card__meta">Total Loged In</p>
            </div>
          </div>
        </div>
        <!-- // .col-md-3 -->
        <div class="col-sm-12 col-lg-6 col-xl-3" v-if="summary">
          <div class="c-state-card">
            <div class="c-state-card__icon c-state-card__icon--warning">
              <i class="el-icon-picture"></i>
            </div>
            <div class="c-state-card__content">
              <h5 class="c-state-card__number">
                {{ summary.total_update_photo.toLocaleString("ID") }}
              </h5>
              <p class="c-state-card__meta">Total Upload Photo</p>
            </div>
          </div>
        </div>
        <!-- // .col-md-3 -->
        <div class="col-sm-12 col-lg-6 col-xl-3" v-if="summary">
          <div class="c-state-card">
            <div class="c-state-card__icon c-state-card__icon--error">
              <i class="el-icon-lock"></i>
            </div>
            <div class="c-state-card__content">
              <h5 class="c-state-card__number">
                {{ summary.total_not_default_password.toLocaleString("ID") }}
              </h5>
              <p class="c-state-card__meta">Not Default Passwd</p>
            </div>
          </div>
        </div>
        <!-- // .col-md-3 -->
      </div>
      <div class="row">
        <div class="col-12">
          <vue-good-table
            v-loading="loading"
            mode="remote"
            :columns="columns"
            :rows="rows"
            :totalRows="totalRecords"
            @on-page-change="onPageChange"
            @on-per-page-change="onPageChange"
            @on-sort-change="onSortChange"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true,
              disableSelectInfo: true,
            }"
            :pagination-options="{
              enabled: true,
              mode: 'pages',
            }"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'name'">
                <el-row type="flex" justify="center">
                  <el-col :span="4">
                    <el-image
                      style="width: 40px; height: 40px; border-radius: 50%"
                      fit="cover"
                      :src="props.row.image"
                    >
                    </el-image>
                  </el-col>
                  <el-col :span="20">
                    {{ props.row.name.toUpperCase() }}
                  </el-col>
                </el-row>
              </span>
              <span v-else-if="props.column.field == 'npp'">
                <el-tag size="mini" type="info">{{ props.row.email }}</el-tag
                ><br />
                <el-tag size="mini" type="success">{{ props.row.npp }}</el-tag>
              </span>
              <span v-else-if="props.column.field == 'gender'">
                <p v-if="props.row.gender == 1">Laki - laki</p>
                <p v-else-if="props.row.gender == 0">Perempuan</p>
                <p v-else>-</p>
              </span>
              <span v-else-if="props.column.field == 'position_name'">
                <el-tag size="mini" type="info">{{
                  props.row.position_name
                }}</el-tag
                ><br />
                {{ props.row.occupation }}
              </span>
              <span v-else-if="props.column.field == 'is_default_password'">
                <el-tag
                  size="mini"
                  :type="
                    props.row.is_default_password == 1 ? 'warning' : 'success'
                  "
                  >{{
                    props.row.is_default_password == 1 ? "YES" : "NO"
                  }}</el-tag
                ><br />
              </span>
              <span v-else-if="props.column.field == 'last_login_at'">
                <p v-if="props.row.last_login_at != null">
                  {{ props.row.last_login_at }}
                </p>
                <p v-else>-</p>
              </span>
              <span v-else-if="props.column.field == 'action'">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="View Log"
                  placement="top"
                >
                  <el-button
                    size="mini"
                    icon="el-icon-refresh"
                    type="primary"
                    circle
                    @click="showLog(props.row.originalIndex)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Reset Password"
                  placement="top"
                >
                  <el-button
                    size="mini"
                    icon="el-icon-unlock"
                    type="warning"
                    circle
                    @click="
                      showResetPasswordConfirmation(props.row.originalIndex)
                    "
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Edit / View"
                  placement="top"
                >
                  <el-button
                    size="mini"
                    icon="el-icon-edit"
                    circle
                    @click="editUser(props.row.originalIndex)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Delete"
                  placement="top"
                >
                  <el-button
                    size="mini"
                    icon="el-icon-delete"
                    type="danger"
                    circle
                    @click="showAlertDelete(props.row.originalIndex)"
                  ></el-button>
                </el-tooltip>
                <!-- <el-button size="mini" type="danger" icon="el-icon-delete" @click="showAlertDelete(props.row.id)" circle></el-button> -->
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>

    <el-dialog title="Import" :visible.sync="dialogVisible" width="40%">
      <el-alert
        class="u-mb-small"
        v-if="errorMessage"
        :title="errorMessage"
        type="error"
        show-icon
      >
      </el-alert>
      <span
        >Import data employee, gunakan template berikut:
        <a href="/master-data-template.xlsx">Template</a></span
      >
      <br />
      <el-table :data="rulesData" v-loading="loadingImport">
        <el-table-column property="name" label="Name"></el-table-column>
        <el-table-column property="rules" label="Rules"></el-table-column>
      </el-table>
      <el-upload
        class="u-mt-small u-text-center"
        :show-file-list="false"
        :action="actionURL"
        :headers="headers"
        :on-success="importSuccess"
        :on-error="importError"
        :on-progress="importProgress"
      >
        <el-button type="primary">Import Data</el-button>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Close</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Reset password"
      :visible.sync="dialogForm3Visible"
      width="40%"
    >
      <el-form :model="form">
        <div class="row">
          <div class="col-4">
            <el-image :src="form.image"></el-image>
          </div>
          <div class="col-8">
            <el-form-item label="NPP">
              <el-input
                v-model="form.npp"
                :disabled="true"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="Name">
              <el-input
                v-model="form.name"
                :disabled="true"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="Password">
          <el-input
            type="password"
            v-model="defaultPassword"
            :disabled="false"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogForm3Visible = false">Cancel</el-button>
        <el-button type="warning" @click="resetPassword()" :loading="loading3"
          >Reset to default password</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="Log" :visible.sync="dialogForm4Visible" width="80%">
      <el-form :model="form">
        <div class="row">
          <div class="col-6">
            <el-form-item label="NPP">
              <el-input
                v-model="form.npp"
                :disabled="true"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-6">
            <el-form-item label="Name">
              <el-input
                v-model="form.name"
                :disabled="true"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <vue-good-table
              v-loading="loading5"
              mode="remote"
              :columns="logs.columns"
              :rows="logs.rows"
              :totalRows="logs.totalRecords"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'entity'">
                  {{
                    props.row.method == "reset-password"
                      ? props.row.method.toUpperCase()
                      : props.row.entity.toUpperCase()
                  }}
                </span>
                <span v-else-if="props.column.field == 'is_succeed'">
                  <el-tag type="success" v-if="props.row.is_succeed" size="mini"
                    >Success</el-tag
                  >
                  <el-tag type="danger" v-if="!props.row.is_succeed" size="mini"
                    >Failed</el-tag
                  >
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogForm4Visible = false">Close</el-button>
      </span>
    </el-dialog>

    <EditEmployee
      ref="editEmployee"
      :visible="dialogForm2Visible"
      :form="form"
    />
    <AddEmployee
      ref="addEmployee"
      :visible="dialogFormAddVisible"
      :region="params.region"
    />
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import api from "@/api/employees";
import regions from "@/api/regions";
import branches from "@/api/branches";
import outlets from "@/api/outlets";
import Select2 from "v-select2-component";
import { mapActions } from "vuex";
// import fileDownload from "js-file-download";
import moment from "moment";
import EditEmployee from "@/components/EditEmployee";
import AddEmployee from "@/components/AddEmployee";

export default {
  components: {
    "vue-good-table": VueGoodTable,
    Select2,
    EditEmployee,
    AddEmployee,
  },
  data() {
    return {
      dialogVisible: false,
      headers: {
        "x-api-key": "BmSaBwIdYAgrljryhVxobDWM8ijDii4i",
        "x-access-token": localStorage.getItem("accessToken"),
      },
      rulesData: [
        {
          name: "npp",
          rules: "required, unique, max: 20 chars, min: 5 chars",
        },
        {
          name: "name",
          rules: "required",
        },
        {
          name: "outlet_code",
          rules: "required, registered in database outlets",
        },
        {
          name: "position",
          rules: "required",
        },
      ],
      columns: [
        {
          label: "Employee",
          field: "name",
          width: "350px",
          sortable: false,
        },
        {
          label: "Email / NPP",
          field: "npp",
          sortable: false,
        },
        {
          label: "Position",
          field: "position_name",
          sortable: false,
        },
        {
          label: "Outlet",
          field: "outlet_name",
          sortable: false,
        },
        {
          label: "Gender",
          field: "gender",
          sortable: false,
        },
        {
          label: "Last Login",
          field: "last_login_at",
          sortable: true,
        },
        {
          label: "Default password",
          field: "is_default_password",
          thClass: "u-text-center",
          tdClass: "u-text-center",
          sortable: false,
        },
        {
          label: "Action",
          field: "action",
          thClass: "u-text-center",
          tdClass: "u-text-center",
          width: "180px",
          sortable: false,
        },
      ],
      rows: [],
      totalRecords: 0,
      page: 1,
      perPage: 10,
      regions: [],
      branches: [],
      outlets: [],
      positions: [
        {
          id: 1,
          text: "Pimpinan",
        },
        {
          id: 2,
          text: "Customer Service",
        },
        {
          id: 3,
          text: "Teller",
        },
        {
          id: 4,
          text: "Satpam",
        },
        {
          id: 5,
          text: "BNI Digital Assistant",
        },
      ],
      params: {
        region: "",
        branch: "",
        outlet: "",
        q: "",
        position: "",
        default_password: "",
        last_login: "",
      },
      passwords: [
        {
          id: 99,
          text: "All",
        },
        {
          id: 1,
          text: "Default Password",
        },
        {
          id: 2,
          text: "Not Default Password",
        },
      ],
      loading: false,
      loading2: false,
      loadingImport: false,
      errorMessage: null,
      actionURL: "https://master-api.squ-bss.com/v1/employees/import",
      dialogForm2Visible: false,
      dialogFormAddVisible: false,
      form: {
        id: null,
        npp: null,
        name: null,
        gender: null,
        email: null,
        image: null,
        dob: null,
        position_id: null,
        outlet_code: null,
        outlet_name: null,
        occupation: null,
        phone: null,
        branch_code: null,
        branch_name: null,
        region_code: null,
        region_name: null,
        outlets: null,
        branches: null,
        regions: null,
      },
      defaultPassword: "",
      loading3: false,
      loading4: false,
      loading5: false,
      dialogForm3Visible: false,
      dialogForm4Visible: false,
      logs: {
        rows: [],
        columns: [
          {
            label: "Action",
            field: "entity",
          },
          {
            label: "Status",
            field: "is_succeed",
          },
          {
            label: "Message",
            field: "message",
          },
          {
            label: "Date",
            field: this.dateField,
          },
        ],
        totalRecords: 0,
      },
      user_role_id: localStorage.getItem("user_role_id"),
      summary: null,
      // positions: [
      //     {id: 1, name: 'Pimpinan'},
      //     {id: 2, name: 'Customer Service'},
      //     {id: 3, name: 'Teller'},
      //     {id: 4, name: 'Satpam'}
      // ]
    };
  },
  created() {
    if (this.user_role_id == 1) {
      this.fetch();
      this.fetchRegions();
      this.fetchSummary();
    } else if (this.user_role_id == 2) {
      this.params.region = localStorage.getItem("relation_code");
      this.fetch();
      this.fetchBranches();
    }
  },
  methods: {
    ...mapActions(["logout"]),
    dateField(rowObj) {
      return moment(rowObj.created_at).format("dddd, DD MMMM YYYY / H:mm:ss");
    },
    fetchSummary() {
      this.loading = true;
      var self = this;
      api
        .summary()
        .then(function (response) {
          self.summary = response.data.data;
          self.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetch() {
      this.loading = true;
      var self = this;
      api
        .get(
          this.page,
          this.perPage,
          this.params.region,
          this.params.branch,
          this.params.outlet,
          this.params.q,
          this.params.position,
          this.params.default_password,
          this.params.last_login
        )
        .then(function (response) {
          self.rows = response.data.data;
          self.totalRecords = response.data.meta.totalRecords;
          self.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    onPageChange(params) {
      console.log(params);
      this.page = params.currentPage;
      this.perPage = params.currentPerPage;
      this.fetch();
    },
    fetchRegions() {
      this.loading = true;
      var self = this;
      regions
        .getAll()
        .then(function (response) {
          //
          var regionsx = [];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.regions = regionsx;
          self.loading = false;
          // console.log(self.regions)
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetchBranches() {
      var self = this;
      branches
        .getAll(this.params.region)
        .then(function (response) {
          //
          var regionsx = [];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.branches = regionsx;
          // console.log(self.branches)
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetchOutlets() {
      var self = this;
      outlets
        .getAll(this.params.region, this.params.branch)
        .then(function (response) {
          //
          var regionsx = [];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.outlets = regionsx;
          // console.log(self.outlets)
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    myChangeEvent(val) {
      console.log(val);
      this.params.region = val;
      this.params.branch = "";
      this.fetchBranches();
      this.fetch();
    },
    mySelectEvent({ id, text }) {
      console.log({ id, text });
    },
    myChangeEvent2(val) {
      console.log(val);
      this.params.branch = val;
      this.params.outlet = "";
      this.fetchOutlets();
      this.fetch();
    },
    myChangeEvent3(val) {
      console.log(val);
      this.params.outlet = val;
      this.fetch();
    },
    myChangeEvent4(val) {
      console.log(val);
      this.params.position = val;
      this.fetch();
    },
    search() {
      this.fetch();
    },
    importSuccess(response) {
      console.log(response);
      this.$message.success("Success import data");
      this.errorMessage = null;
      this.loadingImport = false;
      this.dialogFormVisible = false;
    },
    importError(err) {
      // console.log(err)
      var msg = JSON.parse(err.message);
      this.errorMessage = msg.message;
      // this.$message.error(msg.message);
      this.loadingImport = false;
    },
    importProgress(event) {
      console.log(event);
      this.loadingImport = true;
    },
    onSortChange(param) {
      this.params.last_login = param[0].type;
      this.fetch();
    },
    editUser(id) {
      // console.log(id)
      this.form = {
        id: this.rows[id].id,
        npp: this.rows[id].npp,
        name: this.rows[id].name,
        gender: this.rows[id].gender,
        email: this.rows[id].email,
        image: this.rows[id].image,
        position_id: this.rows[id].position_id,
        dob: this.rows[id].dob,
        outlet_code: this.rows[id].outlet_code,
        outlet_name: this.rows[id].outlet_name,
        branch_code: this.rows[id].branch_code,
        branch_name: this.rows[id].branch_name,
        region_code: this.rows[id].region_code,
        region_name: this.rows[id].region_name,
        occupation: this.rows[id].occupation,
        phone: this.rows[id].phone,
      };
      this.dialogForm2Visible = true;
      // this.fetchRegionForEditUser()
      // this.fetchBranchForEditUser()
      // this.fetchOutletForEditUser()
      // this.fetchOutletForEditUser(this.rows[id].region_code, this.rows[id].branch_code)
      // this.dialogForm2Visible = true
    },
    AddUser() {
      this.dialogFormAddVisible = true;
    },
    showAlertDelete(id) {
      this.$confirm(
        "This will permanently delete the data. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.deleteUser(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    deleteUser(id) {
      var self = this;
      var npp = this.rows[id].npp;
      api
        .deleteUser(npp)
        .then(function (response) {
          self.$message({
            type: "success",
            message: response.data.message,
          });
          self.fetch();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    exportData() {
      var self = this;
      this.loading = true;
      api
        .export(this.params.region, this.params.branch, this.params.outlet)
        .then(function (response) {
          self.loading = false;
          console.log(response);
          const type = response.headers["content-type"];
          const blob = new Blob([response.data], {
            type: type,
            encoding: "UTF-8",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "file.xlsx";
          link.click();
          self.$message({
            type: "success",
            message: "Success export data",
          });
        })
        .catch(function (error) {
          self.loading = false;
          console.log(error);
          self.$message({
            type: "error",
            message: error.response
              ? error.response.data.message
              : "Something went wrong.",
          });
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },

    showResetPasswordConfirmation(id) {
      // console.log(id)
      this.form = {
        id: this.rows[id].id,
        npp: this.rows[id].npp,
        name: this.rows[id].name,
        image: this.rows[id].image,
        region_code: this.rows[id].region_code,
      };

      this.defaultPassword = this.form.npp + "bnisqu" + this.form.region_code;
      this.dialogForm3Visible = true;
    },
    resetPassword() {
      this.loading3 = true;
      var self = this;
      var params = {
        password: this.defaultPassword,
      };
      api
        .resetpassword(this.form.npp, params)
        .then(function (response) {
          self.loading3 = false;
          self.dialogForm3Visible = false;
          self.fetch();
          console.log(response);
          self.$message({
            type: "success",
            message: response.data.message,
          });
        })
        .catch(function (error) {
          self.loading3 = false;
          console.log(error);
          self.$message({
            type: "error",
            message: error.response.data.message,
          });
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },

    showLog(id) {
      // console.log(id)
      this.form = {
        id: this.rows[id].id,
        npp: this.rows[id].npp,
        name: this.rows[id].name,
        image: this.rows[id].image,
      };
      this.dialogForm4Visible = true;
      var self = this;
      this.loading5 = true;
      api
        .getLog(this.form.npp)
        .then(function (response) {
          self.loading5 = false;
          self.logs.rows = response.data.data;
          self.logs.totalRecords = response.data.meta.totalRecords;
        })
        .catch(function (error) {
          self.loading5 = false;
          console.log(error);
          self.$message({
            type: "error",
            message: error.response.data.message,
          });
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },

    dismisForm() {
      this.dialogForm2Visible = false;
    },

    dismisFormAdd() {
      this.dialogFormAddVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom_toolbar {
  display: flex;
  div {
    margin-right: 10px;
  }
}
.el-row--flex.is-justify-center {
  align-items: center !important;
}
.el-image {
  vertical-align: middle !important;
}
.vgt-left-align {
  vertical-align: middle !important;
}
</style>
